<template>
  <a-spin id="LookReport" :spinning="boxSpinning">
    <a-card title="基本信息" :bordered="false">
      <a-page-header style="border: 1px solid rgb(235, 237, 240); margin-bottom: 30px" :title="reportInfo.name" :backIcon="false">
        <template slot="extra">
          <a-button v-if="[1, 2].includes(reportInfo.status)" type="link" key="3"> 报告生成中 </a-button>
          <a-button v-if="reportInfo.wordReportUrl" type="primary" ghost key="2">
            <a download :href="reportInfo.wordReportUrl | filterUrl">下载报告</a>
          </a-button>
          <a-button @click="copyGroupReport" key="1"> 拷贝报告 </a-button>
        </template>
        <a-descriptions size="small" :column="3">
          <a-descriptions-item label="项目名称">
            {{ reportInfo.projectName }}
          </a-descriptions-item>
          <a-descriptions-item label="报告类型">
            <span v-if="reportInfo.reportType == 1">校级团体报告</span>
            <span v-if="reportInfo.reportType == 2">区域团体报告</span>
            <span v-if="reportInfo.reportType == 3">单校对比报告</span>
            <span v-if="reportInfo.reportType == 4">多校对比报告</span>
          </a-descriptions-item>
          <a-descriptions-item label="机构名称">
            {{ reportInfo.organizationName }}
          </a-descriptions-item>
          <a-descriptions-item label="学段">
            {{ periods[reportInfo.period] || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="报告日期">
            {{ reportInfo.reportDate }}
          </a-descriptions-item>
          <a-descriptions-item label="创建时间">
            {{ reportInfo.createTime }}
          </a-descriptions-item>
        </a-descriptions>
      </a-page-header>
    </a-card>
    <a-card title="项目信息" :bordered="false">
      <StepsSecond :IsDetails="true" />
    </a-card>
    <a-card title="能力配置" :bordered="false">
      <StepsThird :IsDetails="true" />
    </a-card>
    <a-card title="参数配置" :bordered="false">
      <StepsFourth :IsDetails="true" @reportData="getReportData" />
    </a-card>
  </a-spin>
</template>

<script>
import StepsSecond from '../createReport/steps/StepsSecond'
import StepsThird from '../createReport/steps/StepsThird'
import StepsFourth from '../createReport/steps/StepsFourth'
import $Bus from '@/pages/projectImpl/js/eventBus'

const periods = ['学前', '小学低年级', '小学高年级', '初中', '高中']

export default {
  name: 'LookReport',
  components: { StepsSecond, StepsThird, StepsFourth },
  data() {
    return {
      periods,
      boxSpinning: false,
      reportInfo: {
        reportModule: 0,
      },
    }
  },
  computed: {
    getReportModules() {
      const projectContentOptions = [
        {
          label: '大脑学习能力',
          value: 1,
        },
        {
          label: '基础核心能力',
          value: 2,
        },
        {
          label: '能力分布',
          value: 4,
        },
        {
          label: '能力类型',
          value: 8,
        },
        {
          label: '创新拔尖人才',
          value: 16,
        },
        {
          label: '潜力分析',
          value: 32,
        },
      ]
      return projectContentOptions.filter((item) => this.reportInfo.reportModule & item.value)
    },
  },
  methods: {
    getReportData(data) {
      console.log(data, '-- this.reportInfo ')

      this.reportInfo = data
    },
    //拷贝报告
    copyGroupReport() {
      this.$http.ReportService.copyGroupReport(this.reportInfo.id).then((res) => {
        const { data, message } = res
        this.$message.success(message)
        $Bus.$emit('copyReport', data)
      })
    },
  },
}
</script>

<style lang="less" scoped>
#LookReport {
  height: calc(100vh - 105px);
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
}
</style>
